/* eslint-disable @typescript-eslint/member-ordering */

import { _decorator, Enum, ccenum, Node, CCInteger } from 'cc';
import { DEV, EDITOR } from 'cc/env';
import { setEnumAttr, hasSameEnumEntries } from '../../Utils/Utility';
import BaseAction from './BaseAction';

const { ccclass, property } = _decorator;

export enum DefaultEnhanceAnimationsEnum {
    '<None>' = 0,
}
ccenum(DefaultEnhanceAnimationsEnum);

// 動畫行為
export enum EnhanceAnimationActionType {
    Play,
    Stop,
}

@ccclass('EnhanceAnimationAction')
export default class EnhanceAnimationAction extends BaseAction {
    protected _enumAnimations: any = Enum({});

    @property({ type: Node, displayName: DEV && '動畫元件', tooltip: DEV && '增強型動畫元件 (EnhanceAnimation)' })
    public readonly animation: Node = null;
    @property({ type: Enum(EnhanceAnimationActionType), displayName: DEV && '操作類型', tooltip: DEV && '要進行什麼行為' })
    public readonly type: EnhanceAnimationActionType = EnhanceAnimationActionType.Play;
    @property({
        displayName: DEV && 'EnhanceClip名稱',
        tooltip: DEV && '播放的EnhanceAnimationClip名稱',
        visible(this: EnhanceAnimationAction) {
            return !this.animation;
        },
    })
    public animationClipName: string = '';
    @property({
        displayName: DEV && 'EnhanceClip名稱',
        tooltip: DEV && '播放的EnhanceAnimationClip名稱',
        type: DefaultEnhanceAnimationsEnum,
        visible(this: EnhanceAnimationAction) {
            return !!this.animation;
        },
    })
    public get _animationIndex() {
        if (EDITOR) {
            this._syncInspectorEnums();
        }
        if (this.animation) {
            const { animationClipName } = this;
            if (animationClipName) {
                const animsEnum = this.clipEnum;
                if (animsEnum) {
                    const animIndex = animsEnum[animationClipName];
                    if (animIndex !== undefined) {
                        return animIndex;
                    }
                }
            } else {
                this._refreshInspector();
            }
        }
        return 0;
    }
    public set _animationIndex(value: number) {
        let animsEnum = {};
        if (this.animation) {
            animsEnum = this.clipEnum;
        }
        const animName = value === 0 ? '' : animsEnum[value];
        if (animName !== undefined) {
            this.animationClipName = animName;
            this._refreshInspector();
        }
    }
    @property({
        type: CCInteger,
        displayName: DEV && '起始時間',
        tooltip: DEV && '從哪個時刻開始播放(單位:毫秒)',
        visible() {
            return this.type === EnhanceAnimationActionType.Play;
        },
    })
    public readonly startTime: number = 0;

    private get clipEnum() {
        return (this.animation.getComponent('EnhanceAnimation') as any)?.getClipsEnum() ?? DefaultEnhanceAnimationsEnum;
    }

    private _refreshInspector() {
        this._updateAnimEnum();
    }

    private _getAnimEnumSource() {
        if (this.animation) {
            return this.clipEnum;
        }
        return DefaultEnhanceAnimationsEnum;
    }

    private _updateAnimEnum() {
        const animEnum = this._getAnimEnumSource();
        this._enumAnimations = Enum({});
        Object.assign(this._enumAnimations, animEnum);
        Enum.update(this._enumAnimations);
        setEnumAttr(this, '_animationIndex', this._enumAnimations);
    }

    // 每次編輯器讀取列舉時檢查來源是否有變化，避免只在名稱為空或 setter 執行時才刷新，
    // 導致載入時名稱已經有效的實例一直停留在快取的 <None>。
    private _syncInspectorEnums() {
        if (!hasSameEnumEntries(this._getAnimEnumSource(), this._enumAnimations)) {
            this._updateAnimEnum();
        }
    }
}
